import abort from '../../../javascripts/utils/abort';
import onLoad from '../../../javascripts/utils/onLoad';

onLoad<HTMLElement>('.porthole', ($porthole) => {
  const $images = $porthole.querySelector('.porthole__images') ?? abort();
  const $prevButton = $porthole.querySelector<HTMLButtonElement>('[data-porthole="prev"]') ?? abort();
  const $nextButton = $porthole.querySelector<HTMLButtonElement>('[data-porthole="next"]') ?? abort();

  const onScroll = () => {
    $prevButton.disabled = $images.scrollTop < $images.clientHeight;
    $nextButton.disabled = $images.scrollTop > ($images.scrollHeight - $images.clientHeight * 2);
  };

  $images.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  $prevButton.addEventListener('click', (event) => {
    event.preventDefault();
    $images.scrollBy({ top: $images.clientHeight * -1 });
  });

  $nextButton.addEventListener('click', (event) => {
    event.preventDefault();
    $images.scrollBy({ top: $images.clientHeight });
  });
});
